<template>
  <div v-if="totalPages > 1" class="snow-paginator">
    <snow-button
      class="w-100"
      size="sm"
      variant="outline"
      icon="ph ph-caret-left fs-20"
      @click="changePage(-1)"
      :disabled="!pagination.previous"
    />
    <snow-button
      class="w-100"
      size="sm"
      variant="outline"
      icon="ph ph-caret-right fs-20"
      @click="changePage(1)"
      :disabled="!pagination.next"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number
    },
    pagination: {
      type: Object,
      required: true,
      default: () => ({
        next: null,
        previous: null,
        count: 0
      })
    },
    step: {
      type: Number,
      default: 20
    }
  },
  computed: {
    totalPages() {
      const total = Math.ceil(this.pagination.count / this.step);
      return isNaN(total) ? 1 : total;
    }
  },
  methods: {
    changePage(step) {
      this.$emit("input", this.value + step);
      this.$emit("change-page", (this.value + step - 1) * this.step);
    }
  }
};
</script>
<style lang="scss" scoped>
.snow-paginator {
  display: flex;
  align-items: center;
  gap: 6px;

  button {
    width: 108px !important;
  }
}
</style>
